import { call, put, takeEvery, takeLatest, select } from 'redux-saga/effects';
import opportunityApi from '../../api/opportunity';

import Opportunity from '../../models/SFModels/Opportunity';

import {
  FRONT_INFORMATIONS_READY,
  FETCH_SALESFORCE_DATA,
} from '../DataServices/SFDataService/actions';

import * as Actions from './actions';

export function* fetchOpportunity(action) {
  const opportunity = yield call(opportunityApi.fetchOpportunity, action.opportunityId);
  yield put(Actions.opportunityDataTerminateLoading(opportunity));
}

export function* populateOpportunity(action) {
  let opportunity = yield select(state => state.opportunity);
  if (
    action.customerDetails !== null &&
    action.customerAddress !== null &&
    action.customerInformations !== null
  ) {
    if (opportunity === null) {
      opportunity = new Opportunity(
        action.customerDetails.getId(),
        action.customerInformations.getName(),
        action.customerDetails.getPointOfSalesAlreadyUsed(),
        action.customerDetails.getPointOfSalesUsed(),
        action.customerDetails.getNewOpen(),
        action.customerDetails.getInstallationDate(),
        action.customerAddress.getInstallationComment(),
        action.opportunity.getCalendlyLinkCsm(),
        action.opportunity.getContactName(),
        action.opportunity.getContactFirstName(),
        action.opportunity.getContactEmail(),
      );
    } else {
      opportunity = opportunity
        .clone()
        .setId(action.customerDetails.getId())
        .setName(action.customerInformations.getName())
        .setPointOfSalesAlreadyUsed(action.customerDetails.getPointOfSalesAlreadyUsed())
        .setPointOfSalesUsed(action.customerDetails.getPointOfSalesUsed())
        .setNewOpen(action.customerDetails.getNewOpen())
        .setInstallationDate(action.customerDetails.getInstallationDate())
        .setInstallationComment(action.customerAddress.getInstallationComment())
        .setCalendlyLinkCsm(opportunity.getCalendlyLinkCsm())
        .setContactName(opportunity.getContactName())
        .setContactFirstName(opportunity.getContactFirstName())
        .setContactEmail(opportunity.getContactEmail());
    }
  }
  yield put(Actions.opportunityUpdated(opportunity));
}

export function* opportunityListener() {
  yield takeEvery(FETCH_SALESFORCE_DATA, fetchOpportunity);
  yield takeLatest(FRONT_INFORMATIONS_READY, populateOpportunity);
}



// WEBPACK FOOTER //
// ./src/services/SFOpportunityService/saga.js